import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    const form = event.target.closest('form')
    const formData = new FormData(form)
    const originalValue = event.target.dataset.previousValue
    
    fetch(form.action, {
      method: form.method,
      headers: {
        'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(Object.fromEntries(formData))
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        event.target.dataset.previousValue = event.target.value
        const display = this.element.querySelector('.squadron-display')
        if (display) {
          display.textContent = data.squadron || 'None'
        }
        this.showNotification('success', 'Squadron updated successfully')
      } else {
        event.target.value = originalValue
        this.showNotification('error', data.error || 'Failed to update squadron')
      }
    })
    .catch(error => {
      event.target.value = originalValue
      this.showNotification('error', 'An error occurred while updating squadron')
    })
  }

  showNotification(type, message) {
    const notification = document.createElement('div')
    notification.className = `notification notification-${type}`
    notification.innerHTML = `
      <div class="notification-content">
        <i class="fas ${type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'}"></i>
        <span>${message}</span>
      </div>
    `
    document.body.appendChild(notification)
    requestAnimationFrame(() => notification.classList.add('show'))
    
    setTimeout(() => {
      notification.classList.remove('show')
      notification.addEventListener('transitionend', () => notification.remove())
    }, 3000)
  }
}
